module.exports = __webpack_public_path__ + "img/no-avatar.e81dd4ab.svg";